import AttachIcon from '@atlaskit/icon/core/attachment';
import MentionIcon from '@atlaskit/icon/core/mention';
import MicrophoneIcon from '@atlaskit/icon/core/microphone';
import VideoIcon from '@atlaskit/icon/core/video';

export const inputMethods = {
	speech: {
		tooltip: 'Speak your input',
		icon: MicrophoneIcon,
	},
	video: {
		tooltip: 'Record a video',
		icon: VideoIcon,
	},
	attach: {
		tooltip: 'Attach a file',
		icon: AttachIcon,
	},
	mention: {
		tooltip: 'Refer to an object',
		icon: MentionIcon,
	},
} satisfies Record<string, { tooltip: string; icon: (...args: any[]) => JSX.Element }>;

export type InputMethod = keyof typeof inputMethods;
